<!-- 🔵 components/admin/orders/AdminOrderStatusBadge.vue -->
<template>
  <span :class="klass">{{ text }}</span>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({ status: { type: String, default: "new" } });

const map = {
  new: { text: "Прийнято", cls: "bg-pink-200 text-black" },
  pending_payment: { text: "Очікує оплату", cls: "bg-amber-200 text-black" },
  paid: { text: "Оплачено", cls: "bg-green-200 text-black" },
  shipped: { text: "Відправлено", cls: "bg-blue-200 text-black" },
  delivered: { text: "Доставлено", cls: "bg-emerald-200 text-black" },
  canceled: { text: "Скасовано", cls: "bg-gray-200 text-black" },
};
const conf = computed(() => map[props.status] || map.new);
const klass = computed(
  () =>
    `inline-flex px-2 py-0.5 rounded-full text-xs text-center ${conf.value.cls}`,
);
const text = computed(() => conf.value.text);
</script>
